import {
	TReportAPIRequest,
	TReportListFilters,
	TReportListResponse,
	TSavedReport,
	TSaveReportRequest,
	TTasksFilters,
	TUpdateReportRequest,
} from "@/types";

import API from "./api";

class ReportsServicesClass {
	getTasksList(filters: TTasksFilters) {
		return API.post(`/reports/tasks-list`, filters).then(
			(resp) => resp.data
		);
	}

	list(filters?: TReportListFilters) {
		return API.get<TReportListResponse>(`/reports`, {
			params: filters,
		}).then((resp) => resp.data);
	}

	get(id: number) {
		return API.get<TSavedReport>(`/reports/${id}`).then(
			(resp) => resp.data
		);
	}

	save(values: TSaveReportRequest) {
		return API.post<TSavedReport>(`/reports`, values).then(
			(resp) => resp.data
		);
	}

	update(id: number, values: TUpdateReportRequest) {
		return API.patch<TSavedReport>(`/reports/${id}`, values).then(
			(resp) => resp.data
		);
	}

	delete(id: number) {
		return API.delete(`/reports/${id}`);
	}

	generateById(id: number) {
		return API.post(`/reports/${id}/generate`, undefined, {
			responseType: "blob",
		});
	}

	preview(values: TReportAPIRequest) {
		return API.post<Blob>(`/reports/preview`, values, {
			responseType: "blob",
		});
	}
}

const ReportsServices = new ReportsServicesClass();
export default ReportsServices;
